import { render, staticRenderFns } from "./GroupActive.vue?vue&type=template&id=06cce572&scoped=true"
import script from "./GroupActive.vue?vue&type=script&lang=js"
export * from "./GroupActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cce572",
  null
  
)

export default component.exports